export const ACTIONS = {
	SHOW_MEDIA_VIEWER: 'SHOW_MEDIA_VIEWER',
	HIDE_MEDIA_VIEWER: 'HIDE_MEDIA_VIEWER',
	TRACK_MEDIA_PASTE: 'TRACK_MEDIA_PASTE',
	SHOW_IMAGE_EDITOR: 'SHOW_IMAGE_EDITOR',
	HIDE_IMAGE_EDITOR: 'HIDE_IMAGE_EDITOR',
};
